<template>
  <span class="item-block">
    <span
      class="item-block-title"
      :class="{ uppercase: titleUppercase !== undefined }"
    >
      <slot name="title">{{ title }}</slot>
    </span>
    <span class="item-block-subtitle">
      <slot name="subtitle">{{ subtitle }}</slot>
    </span>
  </span>
</template>

<script>
export default {
  name: "ItemText",

  props: ["title", "subtitle", "titleUppercase"],
};
</script>

<style lang="scss" scoped>
.uppercase {
  text-transform: uppercase;
}

.item-block {
  display: flex;
  justify-content: center;
  flex-direction: column;

  &-title {
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    margin-bottom: 5px;
  }

  &-subtitle {
    font-weight: 400;
    font-size: 12px;
    line-height: 11px;
    color: #9e9e9e;
  }
}
</style>
